import { getRegionFromRequest } from './i18nHelpers';
/* eslint-disable id-length */
const taxInformationByCountry = {
    AE: {
        type: 'vat',
        digitalId: '100450470800003',
        physicalId: '100494230400003',
    },
    AT: {
        type: 'vat',
        digitalId: 'ATU75285148',
        physicalId: 'ATU75285148',
    },
    AU: {
        type: 'gst',
        digitalId: '48 130 545 003',
        physicalId: '48 130 545 003',
    },
    BE: {
        type: 'vat',
        digitalId: 'BE0752676646',
        physicalId: 'BE0752676646',
    },
    BH: {
        type: 'vat',
        digitalId: '220022414500002',
        physicalId: '220022414500002',
    },
    DE: {
        type: 'vat',
        digitalId: 'DE328401078',
        physicalId: 'DE328401078',
    },
    DK: {
        type: 'vat',
        digitalId: 'DK 37 01 30 05',
        physicalId: 'DK 37 01 30 05',
    },
    ES: {
        type: 'vat',
        digitalId: 'N4000456F',
        physicalId: 'N4000456F',
    },
    FI: {
        type: 'vat',
        digitalId: 'FI31263735',
        physicalId: 'FI31263735',
    },
    FR: {
        type: 'vat',
        digitalId: 'FR 01 889583860',
        physicalId: 'FR 01 889583860',
    },
    GB: {
        type: 'vat',
        digitalId: 'GB322664807',
        physicalId: 'GB322664807',
    },
    IE: {
        type: 'vat',
        digitalId: 'IE 3672640SH',
        physicalId: 'IE 3672640SH',
    },
    IS: {
        type: 'vat',
        digitalId: '144310',
        physicalId: '144310',
    },
    IT: {
        type: 'vat',
        digitalId: 'IT 11206150960',
        physicalId: 'IT 11206150960',
    },
    JE: {
        type: 'vat',
        digitalId: '0123213',
        physicalId: '0123213',
    },
    NL: {
        type: 'vat',
        digitalId: 'NL8256.92.295.B01',
        physicalId: 'NL8256.92.295.B01',
    },
    NZ: {
        type: 'gst',
        digitalId: '130452531',
        physicalId: '130452531',
    },
    SA: {
        type: 'vat',
        digitalId: '311859102700003',
        physicalId: '311859102700003',
    },
    SE: {
        type: 'vat',
        digitalId: 'SE502083330601',
        physicalId: 'SE502083330601',
    },
    UK: {
        type: 'vat',
        digitalId: 'GB322664807',
        physicalId: 'GB322664807',
    },
};
/* eslint-enable id-length */
/**
 * Provides tax type and digital & physical tax IDs for countries where we have tax registration requirements
 * @param country The country we need tax information for
 * @returns TaxInformation: tax type (vat, gst, etc.), tax ID for digital purchases, and tax ID for physical purchases
 */
export const getTaxInformationForCountry = (country) => {
    const region = getRegionFromRequest(country);
    const taxInfo = taxInformationByCountry[country];
    if (taxInfo)
        return taxInfo;
    if (region === 'EU')
        return taxInformationByCountry.NL;
};
export const getTaxTypeForCurrency = (currency) => {
    const taxTypes = {
        aed: 'vat',
        aud: 'gst',
        cad: 'gst',
        eur: 'vat',
        gbp: 'vat',
        nzd: 'gst',
        sar: 'vat',
        usd: 'tax',
    };
    return taxTypes[currency];
};
/**
 * @deprecated – Do not use in new development! This calculation should now be done on the backend!
 */
export const getVatInclusivePrice = (price, currency) => {
    const flatTaxRates = {
        aed: 0.05,
        aud: 0.1,
        gbp: 0.2,
        nzd: 0.15,
        sar: 0.15,
    };
    const flatTaxRate = flatTaxRates[currency];
    if (!flatTaxRate)
        return price;
    // If display price is within 1 cent, truncate the cent (AU annual membership price specifically)
    const vatInclusivePrice = Math.round(price * (1 + flatTaxRate));
    if ((vatInclusivePrice - 1) % 10 === 0)
        return vatInclusivePrice - 1;
    if ((vatInclusivePrice + 1) % 10 === 0)
        return vatInclusivePrice + 1;
    return vatInclusivePrice;
};
/**
 * @deprecated – Do not use in new development! This determination should now come fromthe backend
 */
export const isDisplayedVatInclusive = (currency) => {
    return ['aed', 'aud', 'eur', 'gbp', 'nzd', 'sar'].includes(currency);
};
